const localizers = {
  'loading.msg': () => `Ładowanie...`,
  'logon.message.msg': () => `Uwierzytelnienie jest wymagane. Podaj prawidłowy identyfikator i hasło użytkownika.`,
  'logon.button.msg': () => `Zaloguj się...`,
  'SASServer.logonError.msg': () => `Nie można zalogować się do serwera.`,
  'SASServer.genericError.msg': () => `Nie można połączyć się z serwerem.`,
}
export default localizers;
